import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import moment from 'moment'

import Bio from '../components/Bio'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const dateFmt = moment(post.frontmatter.date).format("MMMM Do, YYYY");


    var scripts = [];
    if (post.frontmatter.js_scripts != null) {
      post.frontmatter.js_scripts.forEach(function(src) {
        scripts.push(<script defer="true" key={src} src={src} type="text/javascript" />);        
      }) 
    }

    return (
      <div>
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`}>
          <link href="https://paul.querna.org/atom.xml" rel="alternate" title="Paul Querna's Journal" type="application/atom+xml" />
          {scripts}
        </Helmet>

        <div className="page-header">
          <h1>{post.frontmatter.title}</h1>
        </div>

        <p>
          <small>Published {dateFmt}</small>
        </p>

        <div dangerouslySetInnerHTML={{ __html: post.html }} />

        <hr />

        <Bio />

      </div>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        date
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js